var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "availability-calendar-quater-main d-flex justify-content-start relative",
      class: _vm.mainClasses,
      attrs: {
        id: _vm.quaterId,
        "data-day": _vm.day.id,
        "data-hour": _vm.hour.id
      },
      on: { click: _vm.onClickHandler }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex quater-item-container",
          class: _vm.containerClasses,
          attrs: { id: "container-" + _vm.quaterId }
        },
        _vm._l(_vm.allData.data, function(item, index) {
          return _c(
            "div",
            { key: `quater-item-${index}`, class: _vm.itemClasses(item) },
            [
              _c(
                "popper",
                {
                  ref: `quater-item-${index}`,
                  refInFor: true,
                  attrs: {
                    options: {
                      placement: "right",
                      modifiers: { offset: { offset: "0,0px" } }
                    },
                    trigger: "clickToOpen"
                  },
                  on: { show: _vm.showPopper }
                },
                [
                  _c(
                    "div",
                    { staticClass: "popper" },
                    [
                      _c("PopperStudentInformation", {
                        attrs: {
                          "edit-mode": _vm.editMode,
                          index: index + 1,
                          "is-in-other-company": _vm.isInOtherCompany,
                          "is-in-other-location": _vm.isInOtherLocation,
                          "total-mounted": _vm.allData.data.length,
                          value: item
                        },
                        on: {
                          changeIndex: _vm.onChangeIndex,
                          "edit-admission": _vm.handleEdit,
                          "remove-admission": _vm.handleRemove
                        }
                      })
                    ],
                    1
                  ),
                  _c("template", { slot: "reference" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex-fill quater-item",
                        class: _vm.referenceClasses(item, index),
                        staticStyle: { position: "relative" }
                      },
                      [
                        _c(
                          "p",
                          { class: _vm.isInOtherLocation ? "mb-4" : "mb-0" },
                          [
                            !_vm.isInOtherLocation
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.studentName(item)) + " "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        }),
        0
      ),
      _vm.showAdmissionQuater
        ? _c(
            "div",
            {
              staticClass: "admission-quater w-100 relative",
              class: _vm.admissionQuaterClasses
            },
            [
              _c("div", { staticClass: "mx-2" }, [
                _c("span", { staticClass: "absolute fs-12" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.admission.fullName} - ${_vm.admission.studentSieId}`
                      ) +
                      " "
                  )
                ]),
                _c("span", { staticClass: "absolute fs-16" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.admissionSpaceIndex + 1}/${_vm.frequencyNumber}`
                      ) +
                      " "
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "py-3" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }